/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  GetV2StatisticsTeamsSimulationsUsersByTeamIdParams,
  GetV2StatisticsTeamsReviewsPartialByTeamIdAndReviewIdParams,
  GetV2StatisticsTeamsPrototypesStatisticsByTeamIdAndPrototypeIdParams,
  GetV2StatisticsTeamsAppraisalsUsersByTeamIdParams,
  GetV2StatisticsOrganizationsSimulationsTeamsByOrganizationIdParams,
  GetV2StatisticsOrganizationsAppraisalsTeamsByOrganizationIdParams,
  GetV2StatisticsTeamsSimulationsUsersByTeamIdResponse,
  GetV2StatisticsTeamsReviewsPartialByTeamIdAndReviewIdResponse,
  GetV2StatisticsTeamsPrototypesStatisticsByTeamIdAndPrototypeIdResponse,
  GetV2StatisticsTeamsAppraisalsUsersByTeamIdResponse,
  GetV2StatisticsOrganizationsSimulationsTeamsByOrganizationIdResponse,
  GetV2StatisticsOrganizationsAppraisalsTeamsByOrganizationIdResponse,
} from '../types';

export class UsageStatistics extends Controller {
  async getV2StatisticsTeamsSimulationsUsersByTeamId<
    T extends GetV2StatisticsTeamsSimulationsUsersByTeamIdResponse,
    D,
    C
  >(
    { teamId }: GetV2StatisticsTeamsSimulationsUsersByTeamIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/statistics/teams/${teamId}/simulations/users`,
      axiosConfig
    );
  }

  async getV2StatisticsTeamsReviewsPartialByTeamIdAndReviewId<
    T extends GetV2StatisticsTeamsReviewsPartialByTeamIdAndReviewIdResponse,
    D,
    C
  >(
    {
      teamId,
      reviewId,
    }: GetV2StatisticsTeamsReviewsPartialByTeamIdAndReviewIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/statistics/teams/${teamId}/reviews/${reviewId}/partial`,
      axiosConfig
    );
  }

  async getV2StatisticsTeamsPrototypesStatisticsByTeamIdAndPrototypeId<
    T extends GetV2StatisticsTeamsPrototypesStatisticsByTeamIdAndPrototypeIdResponse,
    D,
    C
  >(
    {
      teamId,
      prototypeId,
    }: GetV2StatisticsTeamsPrototypesStatisticsByTeamIdAndPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/statistics/teams/${teamId}/prototypes/${prototypeId}/statistics`,
      axiosConfig
    );
  }

  async getV2StatisticsTeamsAppraisalsUsersByTeamId<
    T extends GetV2StatisticsTeamsAppraisalsUsersByTeamIdResponse,
    D,
    C
  >(
    { teamId }: GetV2StatisticsTeamsAppraisalsUsersByTeamIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/statistics/teams/${teamId}/appraisals/users`,
      axiosConfig
    );
  }

  async getV2StatisticsOrganizationsSimulationsTeamsByOrganizationId<
    T extends GetV2StatisticsOrganizationsSimulationsTeamsByOrganizationIdResponse,
    D,
    C
  >(
    {
      organizationId,
    }: GetV2StatisticsOrganizationsSimulationsTeamsByOrganizationIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/statistics/organizations/${organizationId}/simulations/teams`,
      axiosConfig
    );
  }

  async getV2StatisticsOrganizationsAppraisalsTeamsByOrganizationId<
    T extends GetV2StatisticsOrganizationsAppraisalsTeamsByOrganizationIdResponse,
    D,
    C
  >(
    {
      organizationId,
    }: GetV2StatisticsOrganizationsAppraisalsTeamsByOrganizationIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/statistics/organizations/${organizationId}/appraisals/teams`,
      axiosConfig
    );
  }
}
